import React, { Component } from "react";
import config from "react-global-configuration";
import RequestApi from "../Miscelania/RequestApi";

import { Link, Redirect } from "react-router-dom";

import Topo from "../Layout/Topo";
import Overlay from "../Miscelania/Overlay";

import Toggle from "react-toggle";
import Select from "react-select";
import InputMask from "react-input-mask";

class BasesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: "",
        type: "",
        status: "open",
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      abbreviation: null,
      sapiens_abbreviation: null,
      rubi_abbreviation: null,
      city: null,
      cep: null,
      email_ptbr: null,
      phone: null,
      transportation: null,
      deslocation: null,
      daily: null,
      force_daily: null,
      observations: null,
      uf: null,
      states: [],
      sigtrip_bases: [],
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.getCep = this.getCep.bind(this);
  }
  // Handlers
  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange(name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if (mode === "reset") {
      this.setState({ overlay: { message: "", type: "", status: "closed" } });
    } else {
      this.setState({
        overlay: { message: message, type: type, status: status },
      });
    }
  }

  handleMessage() {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== "undefined") {
      message = JSON.parse(message);
      var self = this;
      self.setState({
        overlay: {
          message: message.alert_message,
          type: message.alert_type,
          status: "open",
        },
      });
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }

  handleChangeCep(name, event) {
    var change = {};
    var valido = /[0-9]{5}-[0-9]{3}$/.test(event.target.value);
    change[name] = event.target.value;
    this.setState(change);
    if (valido === true) {
      this.getCep(event.target.value);
    } else {
      this.setState({
        city: null,
        uf: null,
      });
    }
  }

  componentDidMount() {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({ loaded: 2 }, this.loadData());
    }
  }

  loadData(event) {
    var self = this;
    var header = this.refs.request_api.header("application/json");
    Promise.resolve(header).then(function (value) {
      var url = config.get("api") + "/base/info/cadastro";
      fetch(url, { method: "GET", mode: "cors", headers: value })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "url");
          if (responseJson.status === "success") {
            self.setState({
              states: responseJson.data.states,
              sigtrip_bases: responseJson.data.sigtrip_bases,
            });
          }
        })
        .then(() => {
          self.setState({
            overlay: { message: "", type: "", status: "closed" },
          });
          if (typeof event === "undefined") {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, "open");
          }
        });
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      abbreviation: this.state.abbreviation,
      rubi_abbreviation: this.state.rubi_abbreviation,
      sapiens_abbreviation: this.state.sapiens_abbreviation,
      city: this.state.city,
      uf: this.state.uf,
      cep: this.state.cep,
      email_ptbr: this.state.email_ptbr,
      phone: this.state.phone,
      transportation: this.state.transportation,
      deslocation: this.state.deslocation,
      daily: this.state.daily,
      force_daily: this.state.force_daily,
      observations: this.state.observations,
      sigtrip_id: this.state.sigtrip_id,
    };
    var header = this.refs.request_api.header("application/json");
    var self = this;
    this.handleAlert("", "", "open");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/base", {
        method: "POST",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          if (responseJson.status === "success") {
            var url = "/base/" + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          } else {
            self.setState({
              overlay: {
                message: responseJson.message,
                type: responseJson.status,
                status: "open",
              },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  getCep(event) {
    var self = this;
    var header = this.refs.request_api.header("application/json");
    var url = config.get("api_correios") + "/" + event + "/json/";
    fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error(error);
      })
      .then((responseJson) => {
        if (typeof responseJson.erro === "undefined") {
          self.setState({
            city: responseJson.localidade,
            uf: responseJson.uf,
          });
        } else {
          self.props.handleAlert("CEP não encontrado", "error", "open");
        }
      });
  }

  render() {
    return (
      <div>
        <Topo></Topo>
        <RequestApi ref={"request_api"} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        {this.state.redirect_url ? (
          <Redirect to={{ pathname: this.state.redirect_url }} />
        ) : (
          ""
        )}
        <div className="container">
          <div className="conteudo">
            <h3 className="page-title pull-left">Cadastrar base</h3>
            <Link to="/bases" className="btn btn-default pull-right">
              <i className="fa fa-chevron-left"></i> Voltar
            </Link>
            <div className="clearfix"></div>
            <hr />
            <form onSubmit={this.add}>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Nome:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={this.state.name}
                    onChange={this.handleChange.bind(this, "name")}
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label>Abreviação:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="abbreviation"
                    value={this.state.abbreviation}
                    onChange={this.handleChange.bind(this, "abbreviation")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Abreviação - RUBI:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="rubi_abbreviation"
                    value={this.state.rubi_abbreviation}
                    onChange={this.handleChange.bind(this, "rubi_abbreviation")}
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label>Abreviação - SAPIENS:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="sapiens_abbreviation"
                    value={this.state.sapiens_abbreviation}
                    onChange={this.handleChange.bind(
                      this,
                      "sapiens_abbreviation"
                    )}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Cidade:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={this.state.city}
                    onChange={this.handleChange.bind(this, "city")}
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label>Estado:</label>
                  <Select
                    className="form-field-name"
                    name="uf"
                    value={this.state.uf}
                    searchable={true}
                    placeholder={"Selecionar estado"}
                    onChange={this.handleSelectChange.bind(this, "uf")}
                    options={this.state.states}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Telefone:</label>
                  <InputMask
                    value={this.state.phone}
                    maskChar={null}
                    name="phone"
                    mask="(99) 9999-99999"
                    className="form-control"
                    onChange={this.handleChange.bind(this, "phone")}
                    placeholder="Telefone da base"
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label>Equivalência no SIGTRIP:</label>
                  <Select
                    className="form-field-name"
                    name="sigtrip_id"
                    value={this.state.sigtrip_id}
                    searchable={true}
                    placeholder={""}
                    onChange={this.handleSelectChange.bind(this, "sigtrip_id")}
                    options={this.state.sigtrip_bases}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Diária obrigatória:</label>
                    <br />
                    <Toggle
                      defaultChecked={this.state.force_daily}
                      checked={this.state.force_daily}
                      aria-label="No label tag"
                      name="force_daily"
                      onChange={this.handleToggleChange.bind(
                        this,
                        "force_daily"
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Diárias adicionais:</label>
                    <input
                      value={this.state.daily}
                      type="text"
                      name="daily"
                      className="form-control"
                      onChange={this.handleChange.bind(this, "daily")}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Verba indenizatória de Transporte:</label>
                    <br />
                    <Toggle
                      defaultChecked={this.state.transportation}
                      checked={this.state.transportation}
                      aria-label="No label tag"
                      name="transportation"
                      onChange={this.handleToggleChange.bind(
                        this,
                        "transportation"
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Verba indenizatória de Deslocamento:</label>
                    <br />
                    <Toggle
                      defaultChecked={this.state.deslocation}
                      checked={this.state.deslocation}
                      aria-label="No label tag"
                      name="deslocation"
                      onChange={this.handleToggleChange.bind(
                        this,
                        "deslocation"
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>CEP:</label>
                  <InputMask
                    maskChar={null}
                    name="cep"
                    mask="99999-999"
                    className="form-control"
                    onChange={this.handleChangeCep.bind(this, "cep")}
                    placeholder="CEP"
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label>E-mail PTBR:</label>
                  <br />
                  <Toggle
                    defaultChecked={this.state.email_ptbr}
                    checked={this.state.email_ptbr}
                    aria-label="No label tag"
                    name="email_ptbr"
                    onChange={this.handleToggleChange.bind(this, "email_ptbr")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Observações:</label>
                    <textarea
                      style={{ height: 200 }}
                      type="text"
                      name="observations"
                      className="form-control"
                      value={this.state.observations}
                      onChange={this.handleChange.bind(this, "observations")}
                    />
                  </div>
                </div>
              </div>
              <hr />
              <button
                type={"submit"}
                className="btn btn-primary btn-lg btn-block"
              >
                <i className="fa fa-fw fa-save"></i> Adicionar base
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default BasesAdd;



// WEBPACK FOOTER //
// ./src/Components/Bases/BasesAdd.js